import { type FC, useCallback } from 'react';

import { useSeriaPlusByLocation } from 'shared/settings/seriaPlusScheme';

import { SeriaPlus } from './SeriaPlus';
import { trackSeriaPlusCarouselArrowClick } from './internal/tracking/trackSeriaPlusCarouselArrowClick';
import { trackSeriaPlusCarouselSlideClick } from './internal/tracking/trackSeriaPlusCarouselSlideClick';
import { trackSeriaPlusWatchProjectsClick } from './internal/tracking/trackSeriaPlusWatchProjectsClick';
import { trackShowSeriaPlusSection } from './internal/tracking/trackShowSeriaPlusSection';

export const SeriaPlusContainer: FC = () => {
  const seriaPlusByLocation = useSeriaPlusByLocation();

  const handleCarouselSlideClick = useCallback((slideIndex: number) => {
    trackSeriaPlusCarouselSlideClick(slideIndex);
  }, []);

  const handleCarouselArrowClick = useCallback((direction: 'left' | 'right') => {
    trackSeriaPlusCarouselArrowClick(direction);
  }, []);

  return seriaPlusByLocation ? (
    <SeriaPlus
      scheme={seriaPlusByLocation}
      onCarouselArrowClick={handleCarouselArrowClick}
      onCarouselSlideClick={handleCarouselSlideClick}
      onView={() => trackShowSeriaPlusSection(seriaPlusByLocation)}
      onWatchProjectsClick={trackSeriaPlusWatchProjectsClick}
    />
  ) : null;
};
